module.exports = __webpack_public_path__ + "static/naes-logo-1344d62285cf74555026c891cbc1c6ed.png";